import { normalizeFilters } from "../../../shared/lib/normalizeFilters";

export const rescheduleKeys = {
  all: ["reschedule"] as const,
  lists: () => [...rescheduleKeys.all, "list"] as const,
  list: (filters?: Record<string, unknown>) =>
    [...rescheduleKeys.lists(), normalizeFilters(filters)] as const,
  count: () => [...rescheduleKeys.all, "count"] as const,
};
